<template>
  <div>
    <a-button
      class="top_btn"
      type="primary"
      v-has="'btn_add'"
      @click="
        () => {
          visibleForm = true;
          titleForm = '添加账号';
        }
      "
    >添加账号</a-button>
    <a-table :columns="columns" :data-source="data" :loading="loading" rowKey="id" :pagination="pagination">
      <span slot="opened_keywords_title">
        已开通数量
        <a-tooltip>
          <template slot="title">统计该账号下，开通客户页面填写的关键词数之和</template>
          <a-icon type="question-circle" theme="twoTone" two-tone-color="#199ED8" />
        </a-tooltip>
      </span>

      <span slot="opened_surplus_keywords_title">
         开通剩余数量
        <a-tooltip>
          <template slot="title">统计该账号下，客户还可以再开通的数量（即开通客户页面，选择semalt账号之后的“剩余关键词数量”）</template>
          <a-icon type="question-circle" theme="twoTone" two-tone-color="#199ED8" />
        </a-tooltip>
      </span>

      <span slot="actual_used_keywords_title">
        实际使用数量
        <a-tooltip>
          <template slot="title">统计该账号下，实际使用关键词数量</template>
          <a-icon type="question-circle" theme="twoTone" two-tone-color="#199ED8" />
        </a-tooltip>
      </span>

      <span slot="status" slot-scope="text, record">
<!--          checked-children="启用"-->
<!--          un-checked-children="停用"-->
        <a-switch
          @click="onChange(record)"
          :checked="text == 1 ? true : false"
        />
      </span>
      <span slot="action" slot-scope="text">
        <a
          @click="
            (record) => {
              visibleForm = true;
              (titleForm = '编辑'), (editId = text.id);
            }
          "
          v-has="'btn_edit'"
        >编辑</a>
      </span>
    </a-table>
    <SemaltForm
      :visible="visibleForm"
      :title="titleForm"
      :editId="editId"
      @changVisible="
        () => {
          this.visibleForm = false;
          this.editId='';
          this.getList();
        }
      "
    />
  </div>
</template>

<script>
import API from "./api";
import SemaltForm from "./components/semaltForm";
const columns = [
  {
    title: "ID",
    dataIndex: "id",
    width: "5%",
    ellipsis: true,
    key: "ID",
  },
  {
    title: "账号",
    dataIndex: "account",
    width: "10%",
    ellipsis: true,
    align:'center',
    key: "account",
  },
  {
    title: "总关键词量",
    dataIndex: "total_keywords",
    width: "10%",
    ellipsis: true,
    align:'center',
    key: "total_keywords",
  },
  {
    dataIndex: 'opened_keywords',
    key: 'opened_keywords',
    width: "10%",
    align:'center',
    slots: { title: 'opened_keywords_title' },
    scopedSlots: { customRender: 'opened_keywords' },
  },
  {
    dataIndex: 'opened_surplus_keywords',
    key: 'opened_surplus_keywords',
    width: "10%",
    align:'center',
    slots: { title: 'opened_surplus_keywords_title' },
    scopedSlots: { customRender: 'opened_keywords' },
  },
  {
    dataIndex: 'actual_used_keywords',
    key: 'actual_used_keywords',
    width: "10%",
    align:'center',
    slots: { title: 'actual_used_keywords_title' },
    scopedSlots: { customRender: 'opened_keywords' },
  },
  {
    title: "状态",
    key: "status",
    width: "10%",
    dataIndex: "status",
    align:'center',
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    width: "200px",
    align:'center',
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "Semalt",
  data() {
    return {
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      visibleForm: false,
      titleForm: "",
      loading: true,
      data: [],
      columns,
      editId: null,
    };
  },
  created() {
    this.$store.state.adminleftnavnum = "/Semalt/SemaltList"; //设置左侧导航2-2 active
  },
  components: { SemaltForm },
  methods: {
    getList() {
      API.Semalt.GET_ASEMALT().then((res) => {
        this.pagination.total=res.data.data.total
        this.pagination.pageSize=res.data.data.per_page
        this.pagination.current=res.data.data.current_page
        this.data = res.data.data.data
        this.loading = false
      });
    },

    onChange(row) {
      let Json = { id: row.id, status: row.status == 0 ? 1 : 0 };
      API.Semalt.CHANG_STATUS([Json]).then(() => {
        this.getList();
      });
    },
    confirm(row) {
      API.Semalt.DELE([row.id]).then(() => {
        this.getList();
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
